/* Created by Interactive 63 - https://interactive63.com */
/**
 * Stepped easing following the CSS Easing Level 1 specification.
 */
import type { EasingFunction } from './cubic-bezier';

export type StepPosition = 'jump-start' | 'jump-end' | 'jump-none' | 'jump-both';

/**
 * Creates a stepped easing. `jump-none` needs at least two steps, so smaller counts are raised
 * to two rather than producing a division by zero.
 */
export function steps(count: number, position: StepPosition): EasingFunction {
  const n = position === 'jump-none' ? Math.max(2, count) : count;
  const jumps = position === 'jump-both' ? n + 1 : position === 'jump-none' ? n - 1 : n;
  return (t) => {
    let step = Math.floor(t * n);
    if (position === 'jump-start' || position === 'jump-both') step += 1;
    if (t >= 0 && step < 0) step = 0;
    if (t <= 1 && step > jumps) step = jumps;
    return step / jumps;
  };
}
